import {
  loadingToggleAction,
  loginConfirmedAction,
  Logout,
} from "../store/actions/AuthActions";
import axiosInstance from "./AxiosInstance";
import {jwtDecode} from "jwt-decode";
import {del, get, post} from "./request";
import {showToastModal} from "../jsx/components/shared/ToastModalSwal";
import {getStoredAuthToken, normalizeAuthToken} from "../utils/authToken";

export function signUp(body) {
  //axios call
  const postData = {
    ...body,
    returnSecureToken: true,
  };
  return axiosInstance.post("/auth/signup", postData, {});
}

export function signUpSC(body) {
  //axios call
  const postData = {
    ...body,
    returnSecureToken: true,
  };
  return axiosInstance.post("/auth/socialMedia", postData, {});
}

export function login(email, password) {
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axiosInstance.post("/auth/signin", postData);
}

export const signOut = async () => {
  try {
    return await get("/auth/signout");
  } catch (err) {
    return Promise.reject(err);
  }
};

export function loginSc({idToken, signedBy, imageUri}) {
  return axiosInstance.post("/auth/signinWithSocialMedia", {
    idToken,
    signedBy,
    imageUri,
  });
}

export function forgotPassword(email) {
  return axiosInstance.post("/auth/sendOTPViaEmail", {email});
}
export const resetPasswordOTPApi = ({email, code, newPassword}) => {
  return axiosInstance.post(`auth/resetPasswordOTP`, {
    email,
    code,
    newPassword,
  });
};

export function getMe(token) {
  const normalizedToken = normalizeAuthToken(token);
  if (!normalizedToken) {
    return Promise.reject(new Error("Session invalide"));
  }

  return axiosInstance.get("auth/getMe", {
    headers: {Authorization: `Bearer ${normalizedToken}`},
  });
}

export function verifyTelephone(body) {
  return axiosInstance.post("auth/sendOTP", body);
}
export function getTurnstileConfig() {
  return axiosInstance.get("auth/turnstile/config");
}
export function verifyCodeOTP(body) {
  return axiosInstance.post("auth/verifyOTP", body);
}
export const WEB_PUSH_TOKEN_KEY = "helpclic_web_push_token";

export const authApi = {};
authApi.updatePassword = async ({body}) => {
  try {
    const {data} = await post(`/auth/password/update`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

authApi.verifyEmail = async ({email}) => {
  try {
    const {data} = await post(`/auth/verifyEmail`, {email});
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

authApi.addFcmToken = async ({body}) => {
  try {
    const {data} = await post(`/auth/addFcmToken`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

authApi.removeFcmToken = async () => {
  try {
    const {data} = await post("/auth/addFcmToken", {fcmToken: null});
    return data;
  } catch (err) {
    return Promise.reject(err);
  } finally {
    localStorage.removeItem(WEB_PUSH_TOKEN_KEY);
  }
};

authApi.removeAccount = async () => {
  try {
    const {data} = await del("/user");
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export function formatError(errorResponse) {
  switch (errorResponse.error) {
    case "Email already in use":
      showToastModal({
        success: false,
        title: "Erreur de connexion",
        message: "L’adresse mail existe déjà.",
        buttonTitle: "Ressayer",
      });
      break;
    case "EMAIL_NOT_FOUND":
      showToastModal({
        success: false,
        title: "Erreur de connexion",
        message: "L’adresse mail est introuvable.",
        buttonTitle: "Ressayer",
      });
      break;
    case "INVALID_PASSWORD":
      showToastModal({
        success: false,
        title: "Erreur de connexion",
        message: "Le mot de passe est invalide.",
        buttonTitle: "Ressayer",
      });
      break;
    case "Wrong credentials":
      showToastModal({
        success: false,
        title: "Erreur de connexion",
        message:
          "L’adresse mail ou le mot de passe sont incorrects. Veuillez vérifiez vos informations de connexion.",
        buttonTitle: "Ressayer",
      });
      break;
    case "USER_DISABLED":
      return "User Disabled";

    default:
      showToastModal({
        title: "Erreur",
        message: errorResponse.error,
      });
      break;
  }
}

export function saveTokenInLocalStorage(token) {
  /*  tokenDetails.expireDate = new Date(
    new Date().getTime() + tokenDetails.expiresIn * 1000
  ); */
  const normalizedToken = normalizeAuthToken(token);
  if (!normalizedToken) {
    throw new Error("Le serveur a retourné une session invalide.");
  }
  localStorage.setItem("token", normalizedToken);
}

export function runLogoutTimer(dispatch, timer, navigate) {
  setTimeout(() => {
    //dispatch(Logout(history));
    dispatch(Logout(navigate));
  }, timer);
}

export function checkAutoLogin(dispatch, navigate, queryClient) {
  const tokenDetailsString = getStoredAuthToken();
  let tokenDetails = "";
  if (!tokenDetailsString) {
    dispatch(Logout(navigate));
    return;
  }

  try {
    tokenDetails = jwtDecode(tokenDetailsString);
  } catch (error) {
    dispatch(Logout(navigate));
    return;
  }
  let expireDate = new Date(tokenDetails.exp * 1000);
  let todaysDate = new Date();

  if (todaysDate > expireDate) {
    dispatch(Logout(navigate));
    return;
  }
  dispatch(loadingToggleAction(true));
  const request = queryClient
    ? queryClient.fetchQuery({
        queryKey: ["getMe"],
        queryFn: () => getMe(tokenDetailsString),
        staleTime: 30_000,
      })
    : getMe(tokenDetailsString);
  return request
    .then((response) => {
      dispatch(loginConfirmedAction(response.data.data));
      dispatch(loadingToggleAction(false));
      // navigate("/");
    })
    .catch(() => {
      dispatch(Logout(navigate));
    });
}
